import axios from 'axios';
import {API} from '../../constants/api';

export const createAxiosInstance = (info: {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  headers?: any;
  data?: any;
  params?: any;
}) => {
  const {url, method = 'GET', headers = {}, data = {}, params = {}} = info;
  const axiosInstance = axios.create({
    baseURL: API.baseUrls[API.currentEnv],
    headers,
  });

  return axiosInstance({url, method, headers, data, params});
};
